import { Controller } from "@hotwired/stimulus"

// Phase 2.7 Tier 1 — Meeting form controller. Tier 1 ships a thin
// wrapper around the standard form lifecycle. Tier 2 will add
// autosave + inline assignee edit (Procore parity).
export default class extends Controller {
  connect() {
    // Hook for future autosave / dirty-tracking; Tier 1 keeps the
    // form stateless.
  }
}
